import { render, staticRenderFns } from "./xntgmanage.vue?vue&type=template&id=159bed84&scoped=true"
import script from "./xntgmanage.vue?vue&type=script&lang=js"
export * from "./xntgmanage.vue?vue&type=script&lang=js"
import style0 from "./xntgmanage.vue?vue&type=style&index=0&id=159bed84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159bed84",
  null
  
)

export default component.exports